"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorAddForm = void 0;
const React = require("react");
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const form_1 = require("client/components/ui/form");
const callable_1 = require("client/components/ui/callable");
// import { Rule } from 'shared/purchase-order';
require("./distributor-add-form.less");
let DistributorAddForm = class DistributorAddForm extends React.Component {
    constructor() {
        super(...arguments);
        this.distributor = {
            name: "",
            contactEmail: "",
            contactEmailTwo: "",
            contactEmailThree: ""
        };
        this.status = form_1.FormStatus.Clean;
        this.errorMessage = "";
        this.handleDistributorChange = (field) => (event) => {
            this.distributor[field] = event.target.value;
        };
        this.handleSubmit = async () => {
            // console.log("this.distribu is ", this.distributor);
            try {
                callable_1.callable(this.props.onSave)(this.distributor);
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.handleCancel = () => {
            try {
                callable_1.callable(this.props.onCancel)();
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.renderFormContent = () => (React.createElement("div", { className: "distributor-add-form" },
            React.createElement(core_1.Typography, { variant: "title" }, "Add a distributor"),
            React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Distributor name", onChange: this.handleDistributorChange("name"), type: "text", required: true, value: this.distributor.name }),
            React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact Email", required: true, onChange: this.handleDistributorChange("contactEmail"), type: "text", value: this.distributor.contactEmail }),
            React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact Email 2", onChange: this.handleDistributorChange("contactEmailTwo"), type: "text", value: this.distributor.contactEmailTwo }),
            React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact Email 3", onChange: this.handleDistributorChange("contactEmailThree"), type: "text", value: this.distributor.contactEmailThree })));
    }
    render() {
        return (React.createElement(form_1.UiForm, { buttons: [
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Save"
            ], loading: false, isChanged: () => true, status: this.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.errorMessage, shouldDisableSave: false }, this.renderFormContent()));
    }
};
__decorate([
    mobx_1.observable
], DistributorAddForm.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], DistributorAddForm.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], DistributorAddForm.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.action
], DistributorAddForm.prototype, "handleDistributorChange", void 0);
__decorate([
    mobx_1.action
], DistributorAddForm.prototype, "handleSubmit", void 0);
__decorate([
    mobx_1.action
], DistributorAddForm.prototype, "handleCancel", void 0);
DistributorAddForm = __decorate([
    mobx_react_1.observer
], DistributorAddForm);
exports.DistributorAddForm = DistributorAddForm;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-add-form/distributor-add-form.tsx
// module id = 3516
// module chunks = 0